import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Radar, ClipboardCheck, LogOut, MapPin } from 'lucide-react';
import { usePortalAuth } from '../../context/PortalAuthContext';
import { PORTAL_LAYOUT } from '../../constants/testIds';

const navItems = [
  { to: '/portal', label: 'Overview', icon: LayoutDashboard, testId: PORTAL_LAYOUT.navOverview, end: true },
  { to: '/portal/audits', label: 'My Heatmaps', icon: Radar, testId: PORTAL_LAYOUT.navAudits },
  { to: '/portal/approvals', label: 'Review Posts', icon: ClipboardCheck, testId: PORTAL_LAYOUT.navApprovals },
];

const PortalLayout = () => {
  const { user, logout } = usePortalAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-stone-50 flex">
      <aside data-testid={PORTAL_LAYOUT.sidebar} className="w-64 bg-white border-r border-stone-200 flex flex-col shrink-0">
        <div className="flex items-center gap-2 px-6 py-6 border-b border-stone-100">
          <span className="w-8 h-8 rounded-lg bg-[#F97316] flex items-center justify-center">
            <MapPin size={16} className="text-white" strokeWidth={2.5} />
          </span>
          <span className="text-lg font-extrabold text-stone-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Ambanji
          </span>
        </div>

        <nav className="flex-1 px-3 py-5 space-y-1">
          {navItems.map(({ to, label, icon: Icon, testId, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium transition ${
                  isActive ? 'bg-[#4F46E5] text-white' : 'text-stone-500 hover:bg-stone-100 hover:text-stone-800'
                }`
              }
            >
              <Icon size={17} strokeWidth={2} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-stone-100">
          <div className="px-3 pb-3 text-xs text-stone-400 truncate">{user?.email}</div>
          <button
            data-testid={PORTAL_LAYOUT.logoutButton}
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-sm font-medium text-stone-500 hover:bg-stone-100 hover:text-red-500 transition"
          >
            <LogOut size={17} strokeWidth={2} />
            Log out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default PortalLayout;
